module.exports = require("@aofl/register-callback");